import { AlbumDto, AuthDto, Capability, FolderPick, SharingResultDto } from '../../..';

export interface UpdateUserFnData {
  displayName?: string;
  capabilities?: Capability[];
}

export interface UpdateUserFnReq {
  auth: AuthDto;
  userId: string;
  data: UpdateUserFnData;
  enableDefaultAlbum: boolean;
  folderPick?: FolderPick;
}

export enum UserDefaultAlbumStatus {
  Created = 'created',
  Removed = 'removed',
  Unmodified = 'unmodified',
  Updated = 'updated',
}

interface UpdateUserFnWithoutDefaultAlbumRes {
  defaultAlbumStatus: UserDefaultAlbumStatus.Unmodified | UserDefaultAlbumStatus.Removed;
}

interface UpdateUserFnWithDefaultAlbumRes {
  album: AlbumDto;
  defaultAlbumStatus: UserDefaultAlbumStatus.Created | UserDefaultAlbumStatus.Updated;
  sharingResult: SharingResultDto;
}

export type UpdateUserFnRes = UpdateUserFnWithoutDefaultAlbumRes | UpdateUserFnWithDefaultAlbumRes;
